import { render, staticRenderFns } from "./my-application.vue?vue&type=template&id=222c49d4&scoped=true&"
import script from "./my-application.vue?vue&type=script&lang=js&"
export * from "./my-application.vue?vue&type=script&lang=js&"
import style0 from "./my-application.vue?vue&type=style&index=0&id=222c49d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c49d4",
  null
  
)

export default component.exports